import { jsx as _jsx } from "react/jsx-runtime";
import { useFormContext } from "react-hook-form";
import { ConsumablesFormStepSection } from "@jti/ui/components/ConsumablesFormStepSection";
import { RadioCard } from "@jti/ui/components/RadioCard";
import { useTranslations } from "@jti/ui/providers/useTranslations";
import { ConsumablesSectionTitle } from "../ConsumablesFormSectionTitle";
import { ConsumablesQuantityItemText } from "../ConsumablesQuantityItemText";
export const ConsumablesQuantitySection = ({ groupName, packagingFormat, step, onChange }) => {
    const { __ } = useTranslations();
    const { register } = useFormContext();
    const quantities = Array.from({ length: packagingFormat.formatQuantity }, (_, index) => index + 1);
    const onQuantityChange = (event) => {
        const quantity = event.target.value;
        onChange(quantity);
    };
    const registerProps = register(groupName, { onChange: onQuantityChange });
    return (_jsx(ConsumablesFormStepSection, { title: _jsx(ConsumablesSectionTitle, { translationKey: "consumablesForm.step.quantity_selection.title", stepCount: step }), "data-testid": "quantity-selection-step", children: quantities.map((quantity) => (_jsx(RadioCard, { value: quantity, groupName: groupName, title: _jsx(ConsumablesQuantityItemText, { quantity: quantity, contentsType: packagingFormat.contentsType, itemsPerPackage: packagingFormat.itemsPerPackage }), ...registerProps }, quantity))) }));
};
//# sourceMappingURL=ConsumablesQuantitySection.js.map